"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { FileText, Users, Search } from "lucide-react";
export default function WorkSystem() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const systems = [{
    number: "01",
    icon: FileText,
    title: "Lead Lawyer",
    description: "Memimpin strategi hukum dan koordinasi tim",
    ref: card1Ref,
    isVisible: card1Visible
  }, {
    number: "02",
    icon: Users,
    title: "Associate Lawyer",
    description: "Menangani aspek teknis dan dokumentasi",
    ref: card2Ref,
    isVisible: card2Visible
  }, {
    number: "03",
    icon: Search,
    title: "Legal Researcher",
    description: "Riset hukum mendalam dan analisis kasus",
    ref: card3Ref,
    isVisible: card3Visible
  }];
  return <section id="work-system" className="dark bg-background text-foreground py-20 px-4">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">Sistem Kerja Tim Berbasis Kompetensi</h2>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {systems.map((system, i) => {
          const Icon = system.icon;
          return <div key={i} data-index={i} ref={system.ref} className={`transition-all duration-500 ${system.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="relative overflow-hidden border border-border bg-secondary shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-medium">
                  <div className="absolute right-4 top-4 select-none font-display text-8xl font-extrabold text-primary/20">
                    {system.number}
                  </div>
                  
                  <CardHeader className="relative z-10">
                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <CardTitle className="text-2xl font-semibold text-foreground">
                      {system.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative z-10">
                    <CardDescription className="text-base text-muted-foreground">
                      {system.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}